import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
// import { adminGetDriverDetailsById } from '../../../utils/ApiEndpointFunctions';
import { updateSalesAgentRatesApi, salesAgentByIdApi, approveOrRejectSalesAgentDocumentsApi, uploadFileApi, adminGetDriverDetailsById, updatePartnerProfileApi, adminGetAllUserList, savePartnerBankDetailsApi, updateDriverDocsApi, updateSalesAgentDocsApi, adminChangePartnerApprovalStatus, getFleetOwnerRideVehiclesApi, getFleetOwnerDriversApi, updatefleetOwnerDriverApi, updateFleetOwnerVehicleApi, getVehicleCategoryListApi, countryListApi, cityByCountryApi } from '../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { bankDetailsInitialValue, bankDetailsValidationSchema, fleetOwnerDriverInitialValue, fleetOwnerDriverValidationSchema, profileDetailsInitialValue, profileValidationSchema, salesAgentInitialValues, salesAgentRatesValidationSchema } from '../../common/Validation';
import DatePicker from "react-datepicker";
import Spinwheel from '../../common/Spinwheel';
import { capitalizeWords, dateFormat } from '../../../utils/HelperFuncitons';
import { S3_URL } from '../../../utils/BaseUrl';
import ConfirmationModal from '../../common/ConfirmationModal';
import CommonTable from '../../common/Table/CommonTable';
import PdfSvgIcon from '../../common/PdfSvgIcon';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';


const ProfileDetails = () => {
    const params = useParams();
    const [id] = useState(params?.id)
    const [allDrivers, setAllDrivers] = useState([])
    const [profileDetails, setProfiledetails] = useState({});
    const [loader, setLoader] = useState(true);
    const [activeTab, setActiveTab] = useState('profile');
      const [driverDetails, setDriverDetails] = useState({});
    const confirmationModalId2 = "confirmationModal2"
    const driverBankModal2 = "driverBankModal2"
    const [detailsType, setDetailsType] = useState({ type: "", loading: false })
    const [fileUpload, setFileUpload] = useState([])
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false)
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
     const [countryOptions, setCountryOptions] = useState([])
      const [cityOptions, setCityOptions] = useState([])


    useEffect(() => {
        console.log("driver details agent", driverDetails)
    }, [driverDetails])

    const filterCites = async (countryId) => {
        try {
            const res = await cityByCountryApi("", countryId);
            if (res.status === 200) {
                let cityOption = res.data?.data?.map(ele => ({
                    label: ele.name,
                    value: ele.id
                }));
                setCityOptions(cityOption);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const filterCountry = async (inputValue) => {
        try {
            const res = await countryListApi(inputValue);
            if (res.status === 200) {
                let countryOption = res.data?.data?.map(ele => ({
                    label: ele.name,
                    value: ele.id   
                }));
                setCountryOptions(countryOption);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        filterCites("")
        filterCountry("")
    }, []) 


    // const getFleetOwnerDriverDetails = async () => {
    //     setLoading(true)
    //     try {
    //         const page = searchParams.get("page") || 1
    //         const res = await getFleetOwnerDriversApi(driverDetails.id, page, limit)
    //         if (res?.status == 200) {
    //             setLoading(false)
    //             setDriverList(res.data?.data?.drivers);
    //             setSelectedDriver(res.data?.data?.drivers)
    //             setPage(Math.ceil(res.data?.data?.totalLength / limit));
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         toast.error(error.response?.data?.message || error?.message)
    //     }
    // }

    //     useEffect(() => {
    //         console.log("driverrrrlistttttt",selectedDriver)
    //   }, [selectedDriver])


    //    useEffect(()=>{
    //        console.log("lisssttt",list)
    //    },[list])


    const genderOptions = [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Other", value: "other" },
    ]



    // const handleChangeStatus = async () => {
    //     try {
    //         setLoader(true)
    //         await adminChangePartnerApprovalStatus(confirmStatus)
    //         await fetchDriverDetails();
    //         document.getElementById('confirmationModal').click()
    //     } catch (error) {
    //         toast.error(error?.response?.data?.message || "Something Went Wrong")
    //         setLoader(false)
    //     }
    // }


    const toggleTab = (tab) => {
        setActiveTab(tab);
    };

    async function handleFileUpload(name, e, formik) {
        try {
            const file = e.target.files[0];
            if (file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("type", "documents")
                setFileUpload([...fileUpload, name])
                const res = await uploadFileApi(formData)
                formik.setFieldTouched(name, true)
                if (res.status === 200 && res.data?.status === 1) {
                    formik.setFieldValue(name, res.data?.data);
                    toast.success("File uploaded");
                }
            }
        } catch (error) {
            formik.setFieldTouched(`image`, true)
            console.log(error)
            if (error?.response === undefined) {
                toast.error("File size is too large")
            }
        }
        setFileUpload([...fileUpload?.filter(ele => ele != name)])
    }

    const fetchDriverDetails = async () => {
        try {
            const res = await adminGetDriverDetailsById(id);
            if (res.status === 200) {
                console.log("driver fetch", res.data.data)
                const { id, role, phone, referralCode, driverDetails, partnerUserDetails, } = res.data.data;
                setDriverDetails({ id, phone, referralCode, role, ...driverDetails[0], ...partnerUserDetails[0] });
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };


    const profileData = [
        { name: "Email", data: driverDetails.email, },
        { name: "Phone", data: driverDetails.phone, },
        { name: "Alternate Phone", data: driverDetails.alternateMobile, },
        { name: "NIN", data: driverDetails.NIN, },
        { name: "Status", data: capitalizeWords(driverDetails.approvalStatus), },
        { name: "Role", data: driverDetails.role?.map(el => capitalizeWords(el))?.join(", "), },
        { name: "Gender", data: driverDetails.gender, },
        { name: "City", data: driverDetails.city, },
        { name: "State", data: driverDetails.state, },
        { name: "Country", data: driverDetails.country, },
        { name: "Zip Code", data: driverDetails.zip, },
        { name: "Address", data: <div>{driverDetails.permanentAddress && `${driverDetails.permanentAddress}, `}{driverDetails.state && `${driverDetails.state}, `}{driverDetails.city && `${driverDetails.city}, `}{driverDetails.zip && `${driverDetails.zip}`}</div>, },
        { name: "Referral Code", data: driverDetails.referralCode, },
    ]

    function handleInputChange(name, e, formik, input, type) {
        if (input == "input") {
            const { value } = e?.target
            if (type == "number" && isNaN(value)) return
            formik.setFieldValue(name, value)
        } else if (input == "date") {
            formik.setFieldValue(name, e)
        } else if (input == "select") {
            let list = [{ name, value: e }]
            if (name == "categoryId") {
                list.push({ name: "modelId", value: "" }, { name: "makeId", value: "" })
            } else if (name == "modelId") {
                list.push({ name: "makeId", value: "" })
            }

            list?.forEach(ele => {
                formik.setFieldValue(ele?.name, ele?.value)
            })
        } else if (input == "address") {
            formik.setFieldValue(name, e?.label)
        }

    }



    const openModal = () => {
        document.getElementById('confirmationModal2Btn').click()
    }

    async function handleDriverDetailSubmit(payload, apiEndPoint) {
        try {
            console.log("in try block")
            setDetailsType({ ...detailsType, loading: true })
            let res;
            if (activeTab === "driver") {
                res = await apiEndPoint({ ...payload })
            }
            res = await apiEndPoint({ ...payload, partnerUserId: id })
            if (res?.status == 200 || res?.status == 201) {
                fetchDriverDetails();
                if (activeTab === "document") {
                    await fetchDriverDetails()
                }
                document.getElementById(detailsFields[activeTab]?.modalId)?.click()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
        }
        setDetailsType({ ...detailsType, loading: false })
    }


    async function handleDetailSubmit(payload, apiEndPoint) {
        try {
            console.log("in try block")
            setDetailsType({ ...detailsType, loading: true })
            const res = await apiEndPoint({ ...payload })
            if (res?.status == 200 || res?.status == 201) {
                fetchDriverDetails();
                document.getElementById(detailsFields[activeTab]?.modalId)?.click()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
        }
        setDetailsType({ ...detailsType, loading: false })
    }


    useEffect(() => {
        if (id) {
            fetchDriverDetails();
        }
    }, [id]);

    // const handleDriverDetailsUpdate=async(values)=>{
    //   const {partnerUserId} = values;
    //   try {
    //     const response = await updatefleetOwnerDriverApi(partnerUserId,values)
    //       if (response.status === 200){
    //         toast.success("update success")

    //       }
    //   } catch (error) {
    //     console.log("something went wrong while updating driver")
    //     toast.error(error.message)
    //   }
    // }

    const detailsFields = {
        "profile": {
            format: [
                { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "alternateMobile", label: "Alternate mobile", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                {
                    name: "country",
                    label: "Country",
                    type: "select",
                    options: countryOptions,
                    handleOnChange: (name, selectedOption, formik, type) => {
                        console.log("Country selectedOption: ", selectedOption);
                        formik.setFieldValue(name, selectedOption);
                        if (selectedOption?.value) {
                            filterCites(selectedOption.value);
                        }
                    }
                },

                {
                    name: "city",
                    label: "City",
                    type: "select",
                    options: cityOptions,
                    handleOnChange: (name, selectedOption, formik, type) => {
                        console.log("City selectedOption: ", selectedOption);
                        formik.setFieldValue(name, selectedOption);
                    }
                },
                 { name: "state", label: "State", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "zip", label: "Zip", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
            ],
            initialvalue: fleetOwnerDriverInitialValue,
            validationSchema: fleetOwnerDriverValidationSchema,
            handleSubmit: (values) => handleDriverDetailSubmit({ ...values, gender: values?.gender?.value,country:values?.country?.label, city:values?.city?.label }, updatePartnerProfileApi),
            modalId: driverBankModal2
        },
    }

    const driverDetailsFormik = useFormik({
        initialValues: detailsFields?.[activeTab]?.initialvalue,
        validationSchema: detailsFields?.[activeTab]?.validationSchema,
        enableReinitialize: true,
        onSubmit: detailsFields?.[activeTab]?.handleSubmit
    })

    // const handleChangeDocumentStatus = async () => {
    //     const promise = approveOrRejectSalesAgentDocumentsApi({ userId: id, keyName: selectDocument.keyName, status: selectDocument.status, restaurantId: selectDocument.restaurantId });
    //     toast.promise(
    //         promise,
    //         {
    //             loading: 'Updating document status...',
    //             success: (res) => {
    //                 if (res.status === 200) {
    //                     driverDetails.approvalStatus = res.data.salesAgentStatus
    //                     setDriverDetails({ ...driverDetails, [selectDocument.keyName]: res.data.docStatus })
    //                     return res.data.message || 'Success';
    //                 }
    //             },
    //             error: (err) => {
    //                 return err.message || 'Something Went Wrong'
    //             }
    //         }
    //     )
    // };

    // const DocumentDisplay = ({ title, document, setSelectedImg, status, keyName, validUpto, number, restaurantId }) => {

    //     if (!document) {
    //         return (
    //             <tr>
    //                 <td>{title}</td>
    //                 <td className='text-center'>{`${title} not available`}</td>
    //             </tr>
    //         );
    //     }

    //     const isPdf = document ? document.split(".").slice(-1)[0] === "pdf" : "";

    //     return (
    //         <tr>
    //             <td>{title}</td>
    //             <td className='text-center'>
    //                 {isPdf ? (
    //                     <Link to={`${S3_URL}/${document}`} className="text-primary">
    //                         <PdfSvgIcon width="100" height="100" />
    //                     </Link>
    //                 ) : (
    //                     <img
    //                         src={`${S3_URL}/${document}`}
    //                         alt={title}
    //                         data-bs-toggle="modal"
    //                         data-bs-target={`#imageViewModal`}
    //                         style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
    //                         onClick={() => setSelectedImg(`${S3_URL}/${document}`)}
    //                     />
    //                 )}
    //             </td>
    //             <td className='text-center'>{validUpto ? dateFormat(validUpto) : ""}</td>
    //             <td className='text-center'>{capitalizeWords(status) || "-"}</td>
    //             {status !== "pending" && <td className='text-center'>
    //                 <div className="dropdown">
    //                     <button
    //                         className=" border-0 bg-white"
    //                         type="button"
    //                         data-bs-toggle="dropdown"
    //                         aria-expanded="false"
    //                     >
    //                         <svg
    //                             xmlns="http://www.w3.org/2000/svg"
    //                             width="16"
    //                             height="16"
    //                             fill="currentColor"
    //                             className="bi bi-three-dots-vertical"
    //                             viewBox="0 0 16 16"
    //                         >
    //                             <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
    //                         </svg>
    //                     </button>
    //                     <ul
    //                         className="dropdown-menu"
    //                         style={{ zIndex: "1000" }}
    //                     >
    //                         {(status === "rejected" || status === "submitted") && <li
    //                             onClick={() => {

    //                                 setSelectDocument({ status: 'approved', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
    //                                 openModal()
    //                             }}
    //                         >
    //                             <a className="dropdown-item" href="#">
    //                                 Approve
    //                             </a>
    //                         </li>}

    //                         {(status === "approved" || status === "submitted") && <li
    //                             onClick={() => {
    //                                 setSelectDocument({ status: 'rejected', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
    //                                 openModal()
    //                             }}
    //                         >
    //                             <a className="dropdown-item" href="#">
    //                                 Reject
    //                             </a>
    //                         </li>}

    //                         <li data-bs-toggle="modal" data-bs-target={`#${driverBankModal2}`} onClick={() => {
    //                             setSelectedDocument({ ...selectedDocument, type: title });
    //                             driverDetailsFormik?.setValues({
    //                                 ...driverDetails,
    //                                 name: {
    //                                     label: salesAgentDocuments?.name,
    //                                     value: salesAgentDocuments?.name,
    //                                 },
    //                             });
    //                             setActiveTab("document")
    //                         }}>
    //                             <a className="dropdown-item" href="#">
    //                                 Edit
    //                             </a>
    //                         </li>
    //                     </ul>
    //                 </div>
    //             </td>}
    //         </tr>
    //     );
    // };


    const tabData = [
        {
            name: "Profile Details", tab: "profile", setTab: toggleTab, data: <div className="row card">
                {/* set tab here */}
                <div className="row mt-3">
                    <div className='d-flex justify-content-end'>
                        <button className='btn btn-primary' onClick={() => driverDetailsFormik.setValues({ ...driverDetails, gender: { label: capitalizeWords(driverDetails?.gender), value: driverDetails?.gender }, country: { label: capitalizeWords(driverDetails?.country), value: driverDetails?.country }, city: { label: capitalizeWords(driverDetails?.city), value: driverDetails?.city }   })} data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Edit</button>
                    </div>
                    <div className="user-details">
                        <table className="table table-md table-hover card-table">
                            <tbody>
                                {
                                    profileData.map((ele, index) => (
                                        <tr key={index}>
                                            <td>{ele.name}:</td>
                                            <td>{ele.data}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        },
        
    ]

    console.log("ddddddddddddddddddddddddddddddddddd",driverDetails)

    return (
        <div className="main-content">
            <div className="container-fluid">

                {loader ? (
                    <div className="text-center">
                        <Spinwheel />
                    </div>
                ) : (
                    <>
                        <div className="row align-items-end">
                            <div className="col-auto">
                                <div className="avatar avatar-xxl header-avatar-top mt-3">
                                    <img src={driverDetails?.profileImage ? `${S3_URL}/${driverDetails?.profileImage}` : "https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"} alt="profile" className="avatar-img rounded-circle border border-4 border-body" />
                                </div>
                            </div>
                            <div className="col mb-3 ms-n3 ms-md-n2">
                                <h1 className="header-title">
                                    {capitalizeWords(driverDetails.name)}
                                </h1>
                            </div>
                            {/* <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                                {(driverDetails.approvalStatus === "pending") ? <><button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal"
                                    data-bs-target={`#confirmationModal`}
                                    onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "approved", userId: id })) }}>Approve</button>
                                    <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal"
                                        data-bs-target={`#confirmationModal`}
                                        onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "rejected", userId: id })) }}>Reject</button></> :
                                    <div className={`badge fs-4  ${driverDetails.approvalStatus === "approved" ? "bg-primary-soft" : "bg-secondary-soft"}`}>{capitalizeWords(driverDetails.approvalStatus)}</div>
                                }
                            </div> */}
                        </div>

                        <div className='d-flex justify-content-between'>
                            <ul className="nav nav-tabs">
                                {
                                    tabData.map((ele, index) => (
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === ele.tab ? 'active' : ''}`}
                                                onClick={() => ele.setTab(ele.tab)}
                                            >
                                                {ele.name}
                                            </button>
                                        </li>
                                    ))
                                }
                            </ul>
                            <div>
                            </div>
                        </div>
                        {
                            tabData.map((ele) => (
                                activeTab === ele.tab ? ele.data : null
                            ))
                        }
                    </>
                )}
                {/* {console.log("zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz",detailsFields[activeTab]?.format)} */}

                {/* <ConfirmationModal
                    handleConfirm={handleChangeStatus}
                    confirmStatus={confirmStatus}
                /> */}
                {/* <ImageViewModal imgUrl={selectedImg} modalId={"imageViewModal"} /> */}
                <button id="confirmationModal2Btn" className='d-none' data-bs-toggle="modal" data-bs-target={`#${confirmationModalId2}`}></button>
                {/* <ConfirmationModal modalId={confirmationModalId2} message={<> Do you want to continue?</>} handleConfirm={() => handleChangeDocumentStatus()} title={"Warning!"} confirmStatus={""} /> */}
                {console.log("driver formik", driverDetailsFormik.values)}
                {/* {console.log("format",detailsFields[activeTab]?.format)} */}
                <AddOrUpdateDetails formik={driverDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading} modalId={driverBankModal2} />

            </div>
        </div>

    );
};

export default ProfileDetails;